import React from 'react';
import MiniCards from 'components/Common/MiniCard';
import { Row } from 'reactstrap';

const dummyMiniCards = [
  {
    title: 'Stock Available',
    iconClass: 'bx-package',
    text: '1200',
  },
  {
    title: 'Purchase Records',
    iconClass: 'bx-purchase-tag',
    text: '15',
  },
  {
    title: 'Active Ingredients',
    iconClass: 'bx-molecule',
    text: '4',
  },
];

const MiniCardsRow = () => {
  return (
    <Row>
      {dummyMiniCards.map((card, idx) => (
        <MiniCards
          key={`mini_card_${idx}`}
          title={card.title}
          iconClass={card.iconClass}
          text={card.text}
        />
      ))}
    </Row>
  );
};

export default MiniCardsRow;
